module.exports = __webpack_public_path__ + "static/img/rwm.3ce7d11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rwm.jpg
// module id = 2k3e
// module chunks = 1